import {mapGetters} from "vuex";


export default {
    computed: {
        ...mapGetters('config', {locale: 'getLocale'}),
        ...mapGetters('config', {currency: 'getCurrency'}),
    },
    methods: {
        /**
         * Преобразует объект цены в текстовое представление
         * @param {{value: number, currency: string}|{min: number, max: number, currency: string}} price
         * @returns {string} Текстовое представление цены
         */
        priceToString(price) {
            const toPriceAndCurr = (value) => {
                return value.toLocaleString(
                    this.locale, {
                        style: 'currency',
                        currency: this.currency,
                        minimumFractionDigits: 2,
                    })
            }

            const toPrice = (value) => {
                return value.toLocaleString(
                    this.locale, {
                        minimumFractionDigits: 2,
                    })
            }

            if (price && typeof price === 'object') {
                const {min, max} = price;
                // Вывод диапазона стоимости
                // если в объекте свойства min max
                if (min && max) {
                    return min === max
                        ? toPriceAndCurr(min)
                        : `от ${toPrice(min)} до\xA0${toPriceAndCurr(max)}`
                }
            }

            if (typeof price === 'number') {
                // Вывод фиксированной стоимости
                // если в объекте свойство value
                return toPriceAndCurr(price)
            }
        }
    }
}
